import { AbstractTypePlacementData, AbstractTypePlacementSchema } from ".";
import * as yup from "yup";
import { ReactSelectOption } from "../../models/generic";
import { FormValidationModel } from "../../models/validation";
import { ReactSelectOptionSchema } from "../generic";

export interface AbstractTypeData {
    active: boolean;
    confirmationEmailTemplate: ReactSelectOption | null;
    description: string | null;
    graderCommentValidationText: string | null;
    gradingEnabled: boolean;
    id: number;
    invitationDeadline: Date | null;
    invitationEmailTemplate: ReactSelectOption | null;
    isHiddenOnForm: boolean;
    name: string;
    placements: AbstractTypePlacementData[];
    sessionDuration: number | null;
    shortName: string;
    submitDeadline: Date | null;
    uploadDeadline: Date | null;
}

export class AbstractType implements FormValidationModel<AbstractTypeData> {
    public data: AbstractTypeData;
    public rules: yup.Schema<AbstractTypeData>;

    public constructor() {
        this.data = {
            active: true,
            confirmationEmailTemplate: null,
            description: null,
            graderCommentValidationText: null,
            gradingEnabled: false,
            id: 0,
            invitationDeadline: null,
            invitationEmailTemplate: null,
            isHiddenOnForm: false,
            name: "",
            placements: [],
            sessionDuration: null,
            shortName: "",
            submitDeadline: null,
            uploadDeadline: null,
        };
        this.rules = yup.object<AbstractTypeData>().shape({
            active: yup.bool().label("Active"),
            confirmationEmailTemplate: ReactSelectOptionSchema.label("Confirmation email template"),
            description: yup.string().nullable(true).max(4000).label("Description"),
            graderCommentValidationText: yup.string().nullable(true).label("Grader comment reject validation").max(200),
            gradingEnabled: yup.bool().label("Grading enabled"),
            id: yup.number().required().label("ID").min(0, "Invalid ID"),
            invitationDeadline: yup.date().required().nullable(true).label("Invitation response deadline"),
            invitationEmailTemplate: ReactSelectOptionSchema.label("Acceptance email template"),
            isHiddenOnForm: yup.bool().label("Hide on submissions form"),
            name: yup.string().required().nullable(true).max(100).label("Name"),
            placements: yup.array().of(AbstractTypePlacementSchema).label("Placements"),
            sessionDuration: yup.number().nullable(true).label("Default session duration"),
            shortName: yup.string().nullable(true).max(20).label("Short name"),
            submitDeadline: yup.date().required().nullable(true).label("Submit deadline"),
            uploadDeadline: yup.date().nullable(true).label("Upload deadline"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractType.ts